// Third-party
import React from 'react';

// Components
import { AdvancedSearch } from '../../../components/search';
import { withErrorBoundary } from '../../../components/errors';
import PageLayout from '../../layouts/PageLayout';
import Navigation from '../partials/FundScreenerNavigation';

// Utils
import { ADVANCED_SEARCH_OPTIONS } from '@/utils/constants';

type Props = {
  selectedOption?: ADVANCED_SEARCH_OPTIONS;
};

const FundScreenerPage = (props: Props) => (
  <PageLayout showHeader={false} pageTitle="Search.PageTitle" pillsFilterElement={<Navigation />} layoutClassName="full-height" mainClassName="search-page-v2">
    <AdvancedSearch {...props} className="all-items" useWindowScrollAncestor />
  </PageLayout>
);

export default withErrorBoundary(FundScreenerPage);
